import { ADD_ORG, CLEAR_ORG } from './orgTypes';

export const setOrg = (org)=> ({
    type: ADD_ORG,
    payload: org
});

export const clearOrg = () => ({
    type: CLEAR_ORG
});